import { Stack, Typography } from "@mui/material";
import type { MetricDataType } from "@entrilia/shared/api/portfolioMonitoringTypes";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import MetricDataTypeIcon from "./MetricDataTypeIcon";

interface Props {
  dataType: MetricDataType;
}

const MetricDataTypeItem = ({ dataType }: Props) => {
  return (
    <Stack direction="row" spacing={1.5}>
      <MetricDataTypeIcon dataType={dataType} color="action" />
      <Typography component="span">{autoFormatCamelCase(dataType)}</Typography>
    </Stack>
  );
};

export default MetricDataTypeItem;
